<template>
    <transition name="fade-transition">
        <div class="vue__lightbox" v-if="isOpen" @click=close @wheel.prevent @touchmove.prevent>
            <div class="vue__lightbox-content" @touchstart="swipeStart" @touchmove="swipe">
                <transition name="scroll-x-transition">
                    <img class="vue__lightbox-image" :key="images[index].image" :src="images[index].image"
                        @click.stop="next">
                </transition>
                <div v-if="prevImage !== index" class="vue__lightbox-control control--prev" @click.stop="prev">
                    <i class="icon-arrow-left"></i>
                </div>
                <div v-if="nextImage !== index" class="vue__lightbox-control control--next" @click.stop="next">
                    <i class="icon-arrow-right"></i>
                </div>
            </div>

            <div class="vue__lightbox-control control--close" @click.stop="close">
                <i class="icon-ui-close"></i>
            </div>
        </div>
    </transition>
</template>
<script>
export default {
    name: 'VueLightbox',
    model: {
        prop: 'index',
        event: 'change',
    },
    props: {
        images: {
            type: Array,
            default: () => [],
        },
        index: {
            type: Number,
            default: undefined
        },
        showThumbs: {
            type: Boolean,
            default: false,
        },
        loop: {
            type: Boolean,
            default: false,
        }
    },
    data: () => ({
        transition: 'scroll-x-transition',
        swipeDone: false,
        swipeX: null,
    }),
    computed: {
        isOpen() {
            return this.index > -1;
        },
        prevImage() {
            if (this.index > 0) return this.index - 1;
            if (this.loop) return this.images.length - 1;
            return this.index;
        },
        nextImage() {
            if (this.index < this.images.length - 1) return this.index + 1;
            if (this.loop) return 0;
            return this.index;
        }
    },
    watch: {
        isOpen(value) {
            if (value) {
                window.addEventListener('keyup', this.keyUp);
            } else {
                window.removeEventListener('keyup', this.keyUp);
            }
        }
    },
    methods: {
        close() {
            this.goto(undefined)
            this.$emit('close', this.index);
        },
        next() {
            const nextImage = this.nextImage;

            this.$emit('next', nextImage);
            this.goto(nextImage)
        },
        prev() {
            const prevImage = this.prevImage;

            this.$emit('prev', prevImage);
            this.goto(prevImage)
        },
        goto(index, transition) {
            this.transition = transition || (this.index < index ? 'scroll-x-transition' : 'scroll-x-reverse-transition');
            this.$emit('change', index);
        },
        keyUp(e) {
            if (
                e.code === 'ArrowRight'
                || e.key === 'ArrowRight'
                || e.key === 'Right'
                || e.keyCode === 39
            ) {
                this.next();
            } else if (
                e.code === 'ArrowLeft'
                || e.key === 'ArrowLeft'
                || e.key === 'Left'
                || e.keyCode === 37
            ) {
                this.prev();
            } else if (
                e.code === 'Escape'
                || e.key === 'Escape'
                || e.key === 'Esc'
                || e.keyCode === 27
            ) {
                this.close();
            }
        },
        swipeStart(e) {
            this.swipeDone = false;
            if (e.changedTouches.length === 1) {
                this.swipeX = e.changedTouches[0].screenX;
            }
        },
        swipe(e) {
            if (!this.swipeDone && e.changedTouches.length === 1) {
                const swipeDistance = e.changedTouches[0].screenX - this.swipeX;
                if (swipeDistance >= 50) {
                    this.prev();
                    this.swipeDone = true;
                } else if (swipeDistance <= -50) {
                    this.next();
                    this.swipeDone = true;
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "frontend/styles/framework";

.vue__lightbox {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    background-color: rgba(0, 0, 0, .4);

    &-content {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
    }

    &-image {
        background-color: #fff;
        position: absolute;
        max-width: 90%;
        max-height: 90%;
        cursor: pointer;
        display: inline-block;
    }

    &-control {
        cursor: pointer;
    }

    .control--next,
    .control--prev {
        position: fixed;
        bottom: 0;
        top: auto;
        right: 0;
        width: 5rem;
        height: 5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: theme-color('primary');
        color: #fff;
    }

    .control--close {
        position: absolute;
        top: 0;
        right: 0;
        margin: 1rem;
        background-color: #fff;
        border-radius: 50%;
        width: 5rem;
        height: 5rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .control--next {
        transform: translateY(0);
    }

    .control--prev {

        transform: translateY(0) translateX(-100%);
        left: auto;
    }

    @media (min-width: $media-tablet) {
        &-content {
            max-width: 1200px;
        }

        .control--prev {
            left: 0;
        }

        .control--next {
            right: 0;
        }

        .control--next,
        .control--prev {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
        }

        &-image {
            max-width: 80%;
        }

        .control--close {
            margin: 5rem;
        }
    }
}
</style>